<template>
  <div>
    <public-holiday-regions-overview />
  </div>
</template>

<script>
import PublicHolidayRegionsOverview from "@/components/resourceCalendar/tabs/PublicHolidayRegionsOverview.vue";

export default {
  components: {
    PublicHolidayRegionsOverview,
  },
};
</script>

<style scoped></style>
